export default __webpack_public_path__ + "static/media/EmojiBad.b35bfb37.svg";